import React from 'react'
import stepbanner from '../../Assets/Images/stepbanner.png'
const StepBanner = () => {
    return (
        <div className="container my-5">
            <div className="row">
                <div className="col">
                    <h2 className='text-center fw-bold' >
                        Our Four Easy Step
                    </h2>

                    <img src={stepbanner} width={"100%"} alt="" />
                </div>
            </div>
        </div>
    )
}

export default StepBanner